// Module
var code = "<div class=\"grid_division\"> <div class=\"main_grid\"> <div class=\"mishion_history\"> <div class=\"mission_title\">MEAL Log</div> </div> </div> </div> <ui-view></ui-view> ";
// Exports
var _module_exports = code;;
var path = 'machines/common/Pages/MealLog/detail/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;